import { updateMerchantInfoPayload } from "@/models/payload/profile";
import profileService from "@/services/merchant";
import { notifications } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

function useUpdateMerchant() {
  const navigate = useNavigate();
  const {
    mutate: updateMerchant,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: updateMerchantInfoPayload) => {
      return profileService.updateMerchant(command);
    },
    onSuccess: () => {
      notifications.show({
        title: "عملیات موفق",
        message: "عملیات با موفقیت صورت پذیرفت",
        color: "green",
      });
      navigate("/dashboard/profile/edit");
    },
  });
  return { updateMerchant, isLoading, isSuccess };
}

export default useUpdateMerchant;
